// Module
var code = `<div class="rubric-element-with-handle-wrapper"><div class="rubric-element-with-handle {{\$ctrl.handleClass}}" tabindex="0" aria-label="{{\$ctrl.handleAriaLabel}}"><i class="{{\$ctrl.handleIcon ? \$ctrl.handleIcon : 'ficon-app-drag-drop'}} rubric-element-drag-handle"></i></div><ng-transclude></ng-transclude></div>`;
// Exports
export default code;